module.exports = __webpack_public_path__ + "img/404_image_fond.c89ba982.png";